import React, { Component } from 'react';
import '../css/style.css';
import './Home.css';
import { Row, Col, Alert, Button } from 'react-bootstrap';
import { translate } from "react-i18next";
import { Link } from 'react-router-dom';
import EventResults from './event/EventResults';
import { getURL } from '../backend/Backend';

import PublicEvents from './pubevent/PublicEvents';
import { Form } from 'react-bootstrap';


class Start extends Component {


    constructor(props) {
        super(props);
        this.searchEvents = this.searchEvents.bind(this);

        this.state = {
            events: [],
            publicEvents: []
        };
    }


    async componentDidMount() {
        console.log("SearchLayout.....");

        this.searchEvents();

    }

    async searchEvents() {


        const response = await fetch(getURL(`start/events`));
        const json = await response.json();
        console.log("received json: " + JSON.stringify(json));

        const presponse = await fetch(getURL(`start/p-events`));
        const pjson = await presponse.json();
        console.log("received json: " + JSON.stringify(pjson));



        let oldState = this.state;
        this.setState({
            ...oldState,
            events: json.content,
            publicEvents: pjson.content
        });

    }
    //style={{"backgroundColor": BLUE_BG}} className="mb-2 ml-1 mr-1"
  

    render() {
        const { t } = this.props;
        return (<div >
             

            <Row className="mt-3">
                <Col md={12} xl={6}>
                    <Alert variant="success" >
                        <Alert.Heading style={{ textAlign: "center" }} className="mt-3 mb-3"><h3>{t("privatesEreignis")}</h3></Alert.Heading>
                        <Row style={{ "height": "100px" }}>
                            <Col>
                                <p style={{ textAlign: "center", fontWeight: "bold" }}>
                                    {t("privatesEreignisText")}
                                </p>
                            </Col>
                        </Row>

                        <hr />



                        <Link to={`/eventAdd`}  >
                            <Button variant="success" block  >
                            <div><i className="fas fa-plus mr-1"></i>  <span >{t("EreignisErstellen")}</span></div>
                            </Button></Link>
                    </Alert>

                </Col>
               
             
                <Col  md={12} xl={6}>
                    <Alert variant="primary" >
                        <Alert.Heading style={{ textAlign: "center" }} className="mt-3 mb-3"><h3>{t("OeffentlicherAnlass")}</h3></Alert.Heading>
                        <Row style={{ "height": "100px" }}>
                            <Col>
                                <p style={{ textAlign: "center", fontWeight: "bold" }}>
                                    {t("OeffentlicherAnlassText")}
                                </p>
                            </Col>
                        </Row>
                        <hr />


                        <Link to={`/loginPage/pubEventAdd`}  >
                            <Button variant="primary" block  >
                            <div><i className="fas fa-plus mr-1"></i> <span >{t("AnlassErstellen")}</span></div>
                            </Button></Link>
                    </Alert>

                </Col>
            </Row>



          
            <Row >
                <Col lg="12" className="mt-3 mb-3 " style={{ "border-bottom": "1px solid "}}>
                    <Form inline> <i className=" fas fa-angle-double-right s24 mr-1"></i><h3 >{" " + t("topPublicEvents")}</h3></Form>
                </Col>
            </Row>
            <Row>
                <Col lg="12">
                    <PublicEvents events={this.state.publicEvents} slg="4" smd="4" />
                </Col>
            </Row>


            <Row >
                <Col lg="12" className=" mt-3 mb-3 " style={{ "border-bottom": "1px solid "}}>
                    <Form inline> <i className="fas fa-angle-double-right s24 mr-0"></i>
                        <h3 >{" " + t("topEvents")}</h3>
                    </Form>
                </Col>
            </Row>

            <Row >
                <Col lg="12">
                    <EventResults events={this.state.events} />
                </Col>

            </Row>
        </div>

        );
    }

}

export default translate("translations")(Start);